<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-21 11:01:42
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 13:38:20
-->
<template>
  <div class="innovative innovative-aneuplan" ref="aneuplan">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require('@/assets/images/m/innovate/product-list-bj.png')" alt="" srcset="">
      <div v-if="language == 'en'" class="innovative-bj-title center_up_down_left_right">
        <p v-html="$t('product.aneuplan.title').replace(' Preoperative', '<br />Preoperative')"></p>
      </div>
      <div v-else class="innovative-bj-title center_up_down_left_right" v-html="$t('product.aneuplan.title')"></div>
    </div>
    <div class="p-t-50 p-b-10">
      <div class="p-l-30 p-r-30">
        <div class="innovative-item-title p-l-25" v-html="$t('product.aneuplan.list[0].title')"></div>
      </div>
      <div class="p-t-28 p-l-14 p-r-20">
        <img class="wid100" :src="$t('product.aneuplan.list[0].img')" alt="" srcset="">
      </div>
      <div class="p-l-30 p-r-30 textj">
        <p class="p-t-20 p-b-20" v-for="item, index in $t('product.aneuplan.list[0].des')" :key="index" v-html="item"></p>
      </div>
    </div>
    <div>
      <div class="aneuplan-characteristics">
        <div class="innovative-container">
          <div class="innovative-item-title" v-html="$t('product.aneuplan.list[1].title')"></div>
          <div class="aneuplan-characteristics-box">
            <div class="p-t-30 p-b-30" v-for="item, index in $t('product.aneuplan.list[1].des')" :key="index">
              <div class="innovative-wrap-item-title fz-30 textc p-b-20" v-html="item.title"></div>
              <p class="innovative-characteristics-item" v-for="$item, $index in item.list" :key="$index" v-html="$item"></p>
            </div>
            <div class="p-t-10 p-b-20">
              <img class="wid100" :src="$t('product.aneuplan.list[1].img')" alt="" srcset="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-container">
      <div class="p-t-30 article">
        <div class="innovative-item-title" v-html="$t('product.aneuplan.article.title')"></div>
        <div class="p-t-15">
          <p class="p-t-15" v-for="item, index in $t('product.aneuplan.article.des')" :key="index" v-html="`${index + 1}. ${item}`"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
</style>

<style lang="less" scoped>
.m .innovative-aneuplan {
  .aneuplan-characteristics {
    background-image: url('~@/assets/images/innovate/AneuPlan/m_3.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
    padding: 20px 0;
    .aneuplan-characteristics-box {
      background: #FFFFFF;
      box-shadow: 0px 4px 12px 4px rgba(81,170,255,0.1);
      padding: 30px;
    }
  }
}
</style>
